const proxyImage = (
  url,
  options = { w: 100, h: 100, fit: "contain", output: "webp" }
) => {
  if (!url) return "";

  // Remove protocol (required by Weserv)
  const cleanUrl = url.replace(/^https?:\/\//, "");

  // Build query parameters
  const params = new URLSearchParams(options).toString();

  // Return final proxied URL
  return `https://images.weserv.nl/?url=${cleanUrl}&${params}`;
};

export default proxyImage;
